/**
 * @generated SignedSource<<529e483d59d804f10934564240a837e2>>
 * @relayHash 257d21373e4fe87ed59a3a372d0ad3b6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c6d87044c41055192b1347a1397c90c0b7b89e443aefe223a0152689fbe2a769

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FilterRefinementTimelineQuery } from './FilterRefinementTimelineQuery.graphql';

const node: PreloadableConcreteRequest<FilterRefinementTimelineQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c6d87044c41055192b1347a1397c90c0b7b89e443aefe223a0152689fbe2a769",
    "metadata": {},
    "name": "FilterRefinementTimelineQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
